module.exports = __webpack_public_path__ + "img/icon-note.eca0f106.svg";